
const state = {
    notifications : []
}

const getters = {
    notifications(state) {
        return state.notifications;
    }
}

const mutations = {
    addNotification(state, notification) {
        if(!notification.type) {
            notification.type = 'info';
        }
        state.notifications.push(notification);
    },
    removeNotification(state, notification) {
        state.notifications = state.notifications.filter(elt => elt !== notification);
    }
}

const actions = {
    addNotification({commit}, notification) {
        commit('addNotification', notification);

        setTimeout(() => commit('removeNotification', notification), 4000);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}